module.exports = __webpack_public_path__ + "static/img/icon_carType01.91f3be1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_carType01.jpg
// module id = O2bj
// module chunks = 1